// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_PurchaseInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Franqueado purchase initiation request body.
 *
 * Required fields:
 *   franquia_id   (int)    — franchise initiating the purchase (scope-checked)
 *   pack_id       (int)    — active pack to purchase
 *   provider_code (string) — gateway to charge (must be registered, enabled for
 *                            ai_credit_topup, support one_off_charge, and match
 *                            the price row's countries for the franchise's country)
 *   request_id    (string) — caller-supplied idempotency key
 */
import { registerContract } from './validate'

export interface AiCredits_PurchaseInput {
franquia_id: number
pack_id: number
provider_code: string
request_id: string
}

registerContract('AiCredits_PurchaseInput', {
  franquia_id:   { type: 'number',  required: true },
  pack_id:       { type: 'number',  required: true },
  provider_code: { type: 'string',  required: true },
  request_id:    { type: 'string',  required: true },
})
